(function () {
  const init = () => {
    const menu = document.querySelector(".anchor-menu");
    const menuWrapper = menu ? menu.closest(".shopify-section") : null;

    const handleSticky = () => {
      if (!menuWrapper || !menu) return;

      const top = menuWrapper.getBoundingClientRect().top;
      const stickyTop = parseInt(getComputedStyle(menuWrapper).top) || 0;

      if (top <= stickyTop) {
        menu.classList.add("is-sticky");
      } else {
        menu.classList.remove("is-sticky");
      }
    };

    window.addEventListener("scroll", handleSticky);
    handleSticky();

    const container = document.querySelector(".anchor-menu__container");
    const links = document.querySelectorAll(".anchor-menu__item");

    if (!container || !links.length) return;

    if (container.dataset.initialized) return;
    container.dataset.initialized = "true";

    const sections = Array.from(links)
      .map((link) => {
        const id = link.getAttribute("href");
        return document.querySelector(id);
      })
      .filter(Boolean);

    const scrollActiveIntoView = () => {
      const active = container.querySelector(".anchor-menu__item.active");
      if (!active) return;

      const containerRect = container.getBoundingClientRect();
      const activeRect = active.getBoundingClientRect();

      const offset =
        activeRect.left -
        containerRect.left -
        containerRect.width / 2 +
        activeRect.width / 2;

      container.scrollBy({
        left: offset,
        behavior: "smooth",
      });
    };

    const setActive = (id) => {
      let changed = false;

      links.forEach((link) => {
        const isActive = link.getAttribute("href") === `#${id}`;

        if (isActive && !link.classList.contains("active")) {
          changed = true;
        }

        link.classList.toggle("active", isActive);
      });

      if (changed) {
        scrollActiveIntoView();
      }
    };

    const getOffset = () => {
      const header = document.querySelector("header");
      const announcement = document.querySelector(".announcement-bar");
      const menu = document.querySelector(".anchor-menu");

      const headerHeight = header ? header.offsetHeight : 0;
      const announcementHeight = announcement ? announcement.offsetHeight : 0;
      const menuHeight = menu ? menu.offsetHeight : 0;

      return headerHeight + announcementHeight + menuHeight + 150;
    };

    document.addEventListener("click", (e) => {
      const link = e.target.closest(".anchor-menu__item");
      if (!link) return;

      const id = link.getAttribute("href");
      const target = document.querySelector(id);

      if (!target) return;

      e.preventDefault();

      const offset = getOffset();

      const top = target.getBoundingClientRect().top + window.scrollY - offset;

      window.scrollTo({
        top,
        behavior: "smooth",
      });

      setActive(id.replace("#", ""));

      history.pushState(null, "", id);
    });

    window.addEventListener("scroll", () => {
      let current = "";

      const offset = getOffset();

      let closestSection = null;
      let closestDistance = Infinity;

      for (let i = 0; i < sections.length; i++) {
        const section = sections[i];
        const rect = section.getBoundingClientRect();

        const distance = Math.abs(rect.top - offset);

        if (rect.bottom > offset && distance < closestDistance) {
          closestDistance = distance;
          closestSection = section;
        }
      }

      if (closestSection) {
        current = closestSection.getAttribute("id");
      }

      if (current) {
        setActive(current);
      }
    });

    // estado inicial
    let current = "";

    const offset = getOffset();

    let closestSection = null;
    let closestDistance = Infinity;

    for (let i = 0; i < sections.length; i++) {
      const section = sections[i];
      const rect = section.getBoundingClientRect();

      const distance = Math.abs(rect.top - offset);

      if (rect.bottom > offset && distance < closestDistance) {
        closestDistance = distance;
        closestSection = section;
      }
    }

    if (closestSection) {
      current = closestSection.getAttribute("id");
    }

    if (current) {
      setActive(current);
    } else if (links.length) {
      const firstId = links[0].getAttribute("href")?.replace("#", "");
      if (firstId) setActive(firstId);
    }
  };

  document.addEventListener("DOMContentLoaded", () => {
    setTimeout(init, 100);
  });

  document.addEventListener("shopify:section:load", () => {
    setTimeout(init, 100);
  });
})();
